import { FirebaseApp, initializeApp } from "firebase/app";
import { FirebaseOptions } from "firebase/app";
import { Firestore, getFirestore } from "firebase/firestore/lite";

import { createContext, useContext } from "react";

import { FirestoreRefs } from "./refs";

export interface InitialisedFirebase {
  firebaseApp: FirebaseApp;
  firestore: Firestore;
  firestoreRefs: FirestoreRefs;
}

/**
 * A react hook to initialise Firebase, manages the loading state and any errors
 *
 * @returns
 */
export const createInitialisedFirebase = (
  options: FirebaseOptions
): InitialisedFirebase => {
  const app = initializeApp(options);
  const fs = getFirestore(app);

  return {
    firebaseApp: app,
    firestore: fs,
    firestoreRefs: new FirestoreRefs(fs),
  };
};

export const FirebaseCtx = createContext<InitialisedFirebase>(
  {} as InitialisedFirebase
);

export const useFirebase = (): InitialisedFirebase => {
  return useContext(FirebaseCtx);
};
